import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { Button, Error, Input, Label } from "../../Components";
import { postAdminAxios } from "../../Services/customService";
import {
  API_DOLLAR_RATE,
  API_DOLLAR_RATE_UPDATE,
} from "../../utils/api/ApiConstant";
import { postFetchAxios } from "../../Services/commonService";

const DollarRate = ({ handleShowHide, dollarRateRefetch }) => {
  const userId = useSelector((state) => state.user?.user?.userId);

  const { values, errors, touched, handleChange, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: {
        dollerRate: 0,
        isCustom: false,
      },
      onSubmit: async (values) => {
        await postFetchAxios({
          url: API_DOLLAR_RATE_UPDATE,
          payload: {
            userId,
            customeDoller: values?.dollerRate,
          },
        });

        dollarRateRefetch();
        handleShowHide();
      },
    });

  const fetchDollerRate = async () => {
    const res = await postFetchAxios({
      url: API_DOLLAR_RATE,
      payload: {
        userId,
      },
    });

    setFieldValue("dollerRate", res?.customeDoller || 0);
  };

  useEffect(() => {
    if (!userId) return;

    fetchDollerRate();
  }, [userId]);

  return (
    <form className="form-order " onSubmit={handleSubmit}>
      <div className="row  m-0 p-0 align-items-end">
        <div className="col-lg-12 col-sm-12 col-12 m-0 p-1">
          <div className="form-group ">
            <Label className="lead_text">Doller Price</Label>
            <Input
              type="number"
              value={values?.dollerRate}
              className="form-control "
              disabled={values?.isCustom}
              name="dollerRate"
              id="dollerRate"
              onChange={handleChange}
              placeholder="Enter dollar rate"
              autoFocus={true}
            />
          </div>
        </div>
      </div>

      <Button type="submit" id="form-submit-btn" hidden={true}></Button>
    </form>
  );
};

export default DollarRate;
